var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C10.09 0 13 2.91005 13 6.5C13 10.09 10.09 13 6.5 13C2.91005 13 0 10.09 0 6.5C0 2.91005 2.91005 0 6.5 0ZM6.5 8.45C6.32761 8.45 6.16228 8.51848 6.04038 8.64038C5.91848 8.76228 5.85 8.92761 5.85 9.1C5.85 9.27239 5.91848 9.43772 6.04038 9.55962C6.16228 9.68152 6.32761 9.75 6.5 9.75C6.67239 9.75 6.83772 9.68152 6.95962 9.55962C7.08152 9.43772 7.15 9.27239 7.15 9.1C7.15 8.92761 7.08152 8.76228 6.95962 8.64038C6.83772 8.51848 6.67239 8.45 6.5 8.45ZM6.5 2.6C6.34079 2.60002 6.18713 2.65847 6.06816 2.76426C5.94919 2.87006 5.87318 3.01584 5.85455 3.17395L5.85 3.25V7.15C5.85018 7.31567 5.91362 7.47502 6.02735 7.59549C6.14108 7.71596 6.29652 7.78845 6.46191 7.79816C6.62729 7.80787 6.79015 7.75406 6.91719 7.64773C7.04424 7.54139 7.12588 7.39056 7.14545 7.22605L7.15 7.15V3.25C7.15 3.07761 7.08152 2.91228 6.95962 2.79038C6.83772 2.66848 6.67239 2.6 6.5 2.6Z",
    fill: "#E63946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4d04d566e277382ea6c6a2d56b9f5976.svg";
export { ForwardRef as ReactComponent };